import getConfig from 'next/config';

export const verticalThemeNameMap = {
  noticias: 'telemundonoticias',
};

export default function getThemesCssPath(vertical) {
  const {
    publicRuntimeConfig: {
      dev,
      themesCssManifest,
      assetPublicPath,
    },
  } = getConfig();

  const themeName = verticalThemeNameMap[vertical] || vertical;

  if (!dev && themesCssManifest && themeName && themesCssManifest[themeName]) {
    // assetPublicPath e.g. '/_next/' + themesCssManifest[vertical] e.g. 'static/css/[hash].css'
    return `${assetPublicPath}${themesCssManifest[themeName]}`;
  }

  return null;
}
